// extracted by mini-css-extract-plugin
module.exports = {"content":"CreatedByInfo_content__q4bVs","fullWidth":"CreatedByInfo_fullWidth__1YzGc","compact":"CreatedByInfo_compact__2kxtt","alert":"CreatedByInfo_alert__3h7Pb"};